import {
    CREATE_PAYMENT_LINK, CREATE_PAYMENT_LINK_SUCCESS, CREATE_PAYMENT_LINK_FAIL,
    CHECK_PAYMENT_STATUS_SUCCESS, CHECK_PAYMENT_STATUS_FAIL,CHECK_PAYMENT_STATUS,
    GET_EXTERNAL_USERS_COUNT,GET_EXTERNAL_USERS_COUNT_SUCCESS,GET_EXTERNAL_USERS_COUNT_FAIL
} from "./actionTypes";
import {GET_USERS} from "../organization/actionTypes";

export const createPaymentLink = payment_payload => ({
    type: CREATE_PAYMENT_LINK,
    payload: { payment_payload }
})

export const createPaymentLinkSuccess = payment_payload => ({
    type: CREATE_PAYMENT_LINK_SUCCESS,
    payload: { payment_payload }
})

export const createPaymentLinkFail = error => ({
    type: CREATE_PAYMENT_LINK_FAIL,
    payload: error,
})

export const checkPaymentStatus = payment_payload => ({
    type: CHECK_PAYMENT_STATUS,
    payload: { payment_payload }
})

export const checkPaymentStatusSuccess = payment_payload => ({
    type: CHECK_PAYMENT_STATUS_SUCCESS,
    payload: payment_payload
})

export const checkPaymentStatusFail = error => ({
    type: CHECK_PAYMENT_STATUS_FAIL,
    payload: error,
})

export const getExternalUsersCount = () => ({
    type: GET_EXTERNAL_USERS_COUNT,
})

export const getExternalUsersCountSuccess = external_users => ({
    type: GET_EXTERNAL_USERS_COUNT_SUCCESS,
    payload: external_users
})

export const getExternalUsersCountFail = error => ({
    type: GET_EXTERNAL_USERS_COUNT_FAIL,
    payload: error,
})